import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { Metric } from "../types"

type MetricState = {
  userMetrics: Metric[]
  promptDate: string | null
  promptId: number | null
  currentMetric: Metricate.Metric
}

const initialState: MetricState = {
  userMetrics: [],
  promptDate: null,
  promptId: null,
  currentMetric: {} as Metricate.Metric,
}

const metricSlice = createSlice({
  name: "metrics",
  initialState,
  reducers: {
    setUserMetrics: (state, action: PayloadAction<Metric[]>) => {
      state.userMetrics = action.payload
    },
    setPromptDate: (state, action: PayloadAction<string | null>) => {
      state.promptDate = action.payload
    },
    setPromptId: (state, action: PayloadAction<number | null>) => {
      state.promptId = action.payload
    },
    setCurrentMetric: (state, action) => {
      state.currentMetric = action.payload
    },
  },
})

export const { setUserMetrics, setPromptDate, setPromptId, setCurrentMetric } = metricSlice.actions

export default metricSlice.reducer
